// import './index.sass'
import Inputmask from 'inputmask';

export default ($root) => {
  const $form = $root.find('.search__form');
  const $simpleSelect = $root.find('.js-simple-select');
  const $hiddenInput = $root.find('.select__input')
  const $duoInput = $root.find('.search__duo-input');
  const $duoInputHidden = $root.find('.search__duo-hidden');


  $(document).on('keypress', function (e) {
    if ($form.length) {
      if (e.keyCode == 13) {
        $form.submit();
        return false;
      }
    }
  });
  $simpleSelect.on('click', '.select__head', function () {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next().fadeOut();
    } else {
      $('.select__head').removeClass('open');
      $('.select__list').fadeOut();
      $(this).addClass('open');
      $(this).next().fadeIn();
    }
  });

  $simpleSelect.each(function () {
    let values = $(this).find('.select__input').val()
      ? $(this).find('.select__input').val().split(', ')
      : [];

    const handleSelects = function () {
      if (
        $(this).find('.checkbox__input:checked').length &&
        !(values.includes($(this).find('.checkbox__input:checked').attr('data-labelname')))
      ) {
        values.push($(this).find('.checkbox__input:checked').attr('data-labelname'));
      } else {
        if ((values.includes($(this).find('.checkbox__input').attr('data-labelname')))) {
          const index = values.indexOf($(this).find('.checkbox__input').attr('data-labelname'));

          if (index !== -1) {
            values.splice(index, 1);
          }
        }
      }
      const firstLable = $(this).closest('.select__list').find(`[data-labelname='${values[0]}']`)
      const labelText = $(firstLable).attr('data-label')
      $(this).parent().prev().find('.select__inner--selected').text(labelText);
      $(this).parent().prev().find('.select__inner--default').css('display', 'none');

      const label = $(this).closest('.js-simple-select').attr('data-label');

      $(this).closest('.js-simple-select').find('.select__label').text(label);
      $(this).parent().prev().find('.select__inner--selected').css('display', 'flex');
      if (values.length > 1) {
        $(this).parent().prev().find('.select__inner--count').css('display', 'flex').text(`+${values.length - 1}`);
      } else if (values.length === 1) {
        $(this).parent().prev().find('.select__inner--count').css('display', 'none');
      } else {
        $(this).parent().prev().find('.select__inner--default').css('display', 'block');
        $(this).parent().prev().find('.select__inner--selected').css('display', 'none');
        $(this).closest('.js-simple-select').find('.select__label').text('');
      }
      $(this).parent().parent().find('.select__input').val(values.join(', '));
    }

    $(this).find('.select__inner--selected').on('click', function (e) {
      e.stopPropagation();
      const lText = $(this).text();
      const checkbox = $(this).parent().parent().find(`[data-label='${lText}']`)
      checkbox.prop('checked', false);
      const labelText = $(checkbox).attr('data-labelname');
      const index = values.indexOf(labelText);

      if (index !== -1) {
        values.splice(index, 1);
        $(this).parent().parent().find('.select__input').val(values.join(', '))
      }
      if (values.length > 1) {
        $(this).parent().find('.select__inner--count').css('display', 'flex').text(`+${values.length - 1}`);
        const text = $($(this).closest('.js-simple-select').find(`[data-labelname="${values[0]}"]`)).attr('data-label');
        $(this).parent().find('.select__inner--selected').text(text);
      } else if (values.length === 1) {
        $(this).parent().find('.select__inner--count').css('display', 'none');
        const text = $($(this).closest('.js-simple-select').find(`[data-labelname="${values[0]}"]`)).attr('data-label');
        $(this).parent().find('.select__inner--selected').text(text);
      } else {
        $(this).parent().find('.select__inner--default').css('display', 'block');
        $(this).parent().find('.select__inner--selected').css('display', 'none');
        $(this).closest('.js-simple-select').find('.select__label').text('');
      }
    })
    $(this).find('.checkbox__input').each(function () {
      const isSelected = values.some(item => $(this).attr('data-labelname') === item);
      if (!isSelected) return;
      $(this).prop('checked', true);
    });
    $(this).on('click', '.select__item', handleSelects);
    $(this).find('.select__item').each(function () {
      const firstLable = $(this).closest('.select__list').find(`[data-labelname='${values[0]}']`)
      const labelText = $(firstLable).attr('data-label')

      $(this).parent().prev().find('.select__inner--selected').text(labelText);
      $(this).parent().prev().find('.select__inner--default').css('display', 'none');

      const label = $(this).closest('.js-simple-select').attr('data-label');

      $(this).closest('.js-simple-select').find('.select__label').text(label);
      $(this).parent().prev().find('.select__inner--selected').css('display', 'flex');
      if (values.length > 1) {
        $(this).parent().prev().find('.select__inner--count').css('display', 'flex').text(`+${values.length - 1}`);
      } else if (values.length === 1) {
        $(this).parent().prev().find('.select__inner--count').css('display', 'none');
      } else {
        $(this).parent().prev().find('.select__inner--default').css('display', 'block');
        $(this).parent().prev().find('.select__inner--selected').css('display', 'none');
        $(this).closest('.js-simple-select').find('.select__label').text('');
      }
    });
  })
  $(document).click(function (e) {
    if (!$(e.target).closest('.js-simple-select').length) {
      $('.select__head').removeClass('open');
      $('.select__list').fadeOut();
    }
  });
  $('.select__close').on('click', function (e) {
    e.preventDefault()
    $('.select__head').removeClass('open');
    $('.select__list').fadeOut();
  });
  $('input').on('change', function () {
    isFormEmpty();
  });
  $('.js-filter-close').on('click', function () {

  });
  $duoInput.on('input', function () {
    if ($(this).hasClass('search__duo-input--left')) {
      $(this).addClass('with-label')
    }
    $(this).parent().addClass('focused');
    const label = $(this).closest('.search__duo').attr('data-label');
    $(this).closest('.search__duo').find('.search__label').text(label);

  })

  $duoInput.on('change', function () {
    $(this).parent().removeClass('focused');
  })
  const areaFromField = document.querySelectorAll('[data-name="area_from"]');
  const areaToField = document.querySelectorAll('[data-name="area_to"]');
  const priceFromField = document.querySelectorAll('[data-name="price_from"]');
  const priceToField = document.querySelectorAll('[data-name="price_to"]');
  const rub = ' млн ₽';
  const sqm = ' м²';
  const options = {
    positionCaretOnClick: "radixFocus",
    radixPoint: " ",
    _radixDance: true,
    numericInput: true,
    placeholder: "0",
    definitions: {
      "0": {
        validator: "[0-9\uFF11-\uFF19]"
      }
    }
  };
  let areaFrom = new Inputmask("от ( 999){+|1}" + sqm, options)
  let areaTo = new Inputmask('до ( 999){+|1}' + sqm, options);
  let priceFrom = new Inputmask('от ( 999){+|1}' + rub, options);
  let priceTo = new Inputmask('до ( 999){+|1}' + rub, options);
  areaFromField.forEach(function (el) {
    areaFrom.mask(el);
  });
  areaToField.forEach(function (el) {
    areaTo.mask(el);
  });
  priceFromField.forEach(function (el) {
    priceFrom.mask(el);
  });
  priceToField.forEach(function (el) {
    priceTo.mask(el);
  });

  const isFormEmpty = function () {
    let isEmpty = true;
    $hiddenInput.each(function () {
      queueMicrotask(() => {
        if ($(this).val()) isEmpty = !$(this).val();

        if (isEmpty) {
          $('.search__clear').prop('disabled', true);
        } else {
          $('.search__clear').prop('disabled', false);
        }
      })
    });
    $duoInput.each(function () {
      queueMicrotask(() => {
        if ($(this).val()) isEmpty = !$(this).val();

        if (isEmpty) {
          $('.search__clear').prop('disabled', true);
        } else {
          $('.search__clear').prop('disabled', false);
        }
      })
    });
  };
  $duoInput.on('input', function () {
    const currentInput = $(this).attr('data-name');
    const $currentHiddenInput = $(`.search__duo-hidden[name="${currentInput}"]`);
    const value = $(this).val().replace(/[^0-9]/g, "");
    $currentHiddenInput.val(value);

  })
  isFormEmpty();

  $root.find('.search__clear').on('click', function () {
    window.location.assign(window.location.pathname);
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/blocks/search-form/index.js